<template>
  <q-item
    ref="item"
    v-ripple="!disable"
    clickable
    :dark="dark"
    :disable="disable || inDebouncePeriod"
    :dense="dense"
    :class="{['bg-' + color]: true, ['text-' + textColor]: !!textColor}"
    @click="onClick"
  >
    <q-item-section
      :style="{'width': sideWidth ? (sideWidth + 'px') : undefined}"
      side
    >
      <q-icon :name="icon" :color="textColor" />
    </q-item-section>
    <q-item-section class="text-bold">
      <q-item-label>{{ label }}</q-item-label>
      <q-item-label v-if="caption" caption>
        {{ caption }}
      </q-item-label>
    </q-item-section>
    <q-item-section
      v-if="iconRight"
      side
    >
      <q-icon :name="iconRight" />
    </q-item-section>
  </q-item>
</template>

<script>
/**
 * A list item for appending new data
 *
 * EVENTS:
 * - click: when element is clicked
 */
export default {
  props: {
    // Button label
    label: {
      type: String,
      required: true
    },
    // Icon to display on side
    icon: {
      type: String,
      default: 'mdi-plus'
    },
    // Button caption
    caption: {
      type: String
    },
    // Button color
    color: {
      type: String,
      default: 'drawer'
    },
    // Button text color
    textColor: {
      type: String
    },
    // Dense mode
    dense: {
      type: Boolean,
      default: false
    },
    sideWidth: {
      type: Number
    },
    disable: {
      type: Boolean,
      default: false
    },
    debounce: {
      type: Number,
      default: 0
    },
    dark: {
      type: Boolean,
      default: false
    },
    iconRight: {
      type: String,
      default: null
    }
  },
  emits: ['click'],
  data () {
    return {
      inDebouncePeriod: false,
      debounceTimer: null
    }
  },
  methods: {
    onClick () {
      if (this.inDebouncePeriod) {
        return
      }
      this.inDebouncePeriod = true
      this.$refs.item.$el.blur()
      this.$emit('click')

      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(() => {
        this.inDebouncePeriod = false
      }, this.debounce)
    }
  }
}
</script>
